<template>
    <div id="us-all-Journey-cart1">
        <div class="edt-cont-box-ov-cont clearfix" id="pageination" v-if="!loading">
            <div class="col-md-4 col-sm-6 ergebnisse" v-for="(journey, journeyid) in Jcarts" :key="journey.id_jrn_journey + '_' + journeyid">
                <!-- <pre>{{journey}}</pre> -->
                <div class="edt-ov-cont-item edt-box-shadow" @click="navigateJourney(journey)">
                    <div class="ov-item-date-label">
                        <p class="ov-item-date">{{ getJourneyDate(journey) }}</p>
                        <div class="ov-item-date-label-bg"></div>
                    </div>
                    <div class="ov-item-status-label">
                        <p class="ov-item-status">{{getBookingState(journey.img.bookable)}}</p>
                        <div class="ov-item-status-label-bg"></div>
                    </div>
                    <div class="ov-item-img">
                        <div class="reise_copyright reisedetail_copyright">{{ journey.img.images[0] ? journey.img.images[0].copyright : "" }}</div>
                        <el-image :src="journey.img.images[0] ? journey.img.images[0].link : ''" fit="cover" style="width: 100%; height: 100%">
                            <div slot="error" class="image-slot-error">
                                <el-image :src="'images/header-logo.jpg'" fit="scale-down" style="width: 100%; height: 100%"></el-image>
                            </div>
                        </el-image>
                    </div>
                    <div class="ov-item-cont">
                        <div class="ov-item-label edt-blue-label">
                            <p>{{ journey.title }}</p>
                            <div></div>
                        </div>
                        <p v-if="journey.einleitung !== undefined && journey.einleitung !== '' && journey.einleitung !== null">{{ journey.einleitung.substr(0, 100) }}</p>
                        <p v-else-if="journey.reisebeschreibung !== undefined && journey.reisebeschreibung !== '' && journey.reisebeschreibung !== null"></p>
                        <p v-else>&nbsp;</p>
                    </div>
                    <div class="ov-item-footer">
                        <label>{{ journey.duration }} Tag{{ journey.duration == 1 ? "" : "e" }}</label>
                        <div>
                            <p class="edt-text-blue" v-if="journey.price == 0">auf Anfrage</p>
                            <p class="edt-text-blue" v-else>{{ journey.price / 1000000 }},- €</p>
                            <div class="ov-item-ftr-label edt-orange-label">
                                <p><span class="glyphicon glyphicon-menu-right"></span></p>
                                <div></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-else><Loader></Loader></div>
        <div class="edt-cont-box-ov-pgn clearfix">
            <div class="col-md-4">
                <h2 class="edt-text-orange">{{ journeyCategory }}</h2>
            </div>
            <div class="col-md-4 edt-pagination"></div>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex"
import Loader from "./Loader"
import moment from "moment"
export default {
    props: ["search"],
    computed: {
        ...mapState(["JourneyStoreSingle", "Settings", "JourneyCategoryStore", "bookingStates"]),
    },
    components: {
        Loader,
    },
    watch: {
        JourneyStoreSingle(newValue, oldValue) {
            if (this.args.category === "search") {
            } else if (this.args.category === "Tagesfahrten") {
                this.Jcarts = this.JourneyStoreSingle.filter((jrn) => jrn.duration === 1)
                this.Jcarts = this.Jcarts.sort((a, b) => new Date(a.date_from) - new Date(b.date_from))
            } else if (this.args.category === "Mehrtagesfahrten") {
                this.Jcarts = this.JourneyStoreSingle.filter((jrn) => jrn.duration > 1)
                this.Jcarts = this.Jcarts.sort((a, b) => new Date(a.date_from) - new Date(b.date_from))
            } else {
                this.Jcarts = this.JourneyStoreSingle
                this.Jcarts = this.Jcarts.sort((a, b) => new Date(a.date_from) - new Date(b.date_from))
            }
        },
    },
    mounted() {
        this.args = core.getPathArgs(["category"])
        if (this.args.category === "search") {
            this.loading = true
            try {
                this.journeyCategory = this.JourneyCategoryStore.find((cat) => cat.id_jrn_category == this.search.category).name
            } catch (error) {
                this.journeyCategory = ""
            }
            core.backend(
                "jrn.listJourneysWeb",
                {
                    id_acc_account: core.id_acc_account,
                    search: this.search.search ? this.search.search.toLowerCase() : "",
                    country: this.search.country == "" ? null : [this.search.country],
                    category: this.search.category == "" ? null : [this.search.category],
                    date: {
                        start: document.querySelector("#datepicker-start").value == "" ? null : moment(document.querySelector("#datepicker-start").value, "DD.MM.YYYY").format("YYYY-MM-DD"),
                        end: document.querySelector("#datepicker-end").value == "" ? null : moment(document.querySelector("#datepicker-end").value, "DD.MM.YYYY").format("YYYY-MM-DD"),
                    },
                    showEinleitung: true,
                    showReisebeschreibung: true,
                },
                (err, res) => {
                    if (err) {
                        this.loading = false
                        return
                    }
                    res.data.rows.forEach((jrney) => {
                        jrney.dates.forEach((date) => {
                            if (date.status == 1) {
                                let _newJourney = JSON.parse(JSON.stringify(jrney))
                                _newJourney.dates = [date]
                                this.Jcarts.push({
                                    title: _newJourney.title,
                                    date_from: date.date_from,
                                    date_till: date.date_till,
                                    einleitung: _newJourney.einleitung,
                                    reisebeschreibung: _newJourney.reisebeschreibung,
                                    duration: date.duration,
                                    price: date.price,
                                    id_jrn_journey: _newJourney.id_jrn_journey,
                                    img: _newJourney,
                                })
                            }
                        })
                    })
                    this.Jcarts = this.Jcarts.sort((a, b) => new Date(a.date_from) - new Date(b.date_from))
                    this.loading = false
                }
            )
        } else if (this.args.category === "Tagesfahrten") {
            this.Jcarts = this.JourneyStoreSingle.filter((jrn) => jrn.duration === 1)
            this.Jcarts = this.Jcarts.sort((a, b) => new Date(a.date_from) - new Date(b.date_from))
        } else if (this.args.category === "Mehrtagesfahrten") {
            this.Jcarts = this.JourneyStoreSingle.filter((jrn) => jrn.duration > 1)
            this.Jcarts = this.Jcarts.sort((a, b) => new Date(a.date_from) - new Date(b.date_from))
        } else {
            this.Jcarts = this.JourneyStoreSingle
            this.Jcarts = this.Jcarts.sort((a, b) => new Date(a.date_from) - new Date(b.date_from))
        }
    },

    data() {
        return {
            Jcarts: [],
            args: {},
            journeyCategory: "",
            loading: false,
        }
    },
    methods: {
        formatter(row, column, cellValue, index) {
            return new Intl.DateTimeFormat("de-DE", { year: "numeric", month: "2-digit", day: "2-digit" }).format(new Date(cellValue))
        },
        formatterPrice(row, column, cellValue, index) {
            var num = cellValue / 1000000
            return num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.") + " €"
        },
        goToDetail(row) {
            core.navigate({ path: "/journeydetail/" + row.id_jrn_journey })
        },
        sortDateFrom(a, b) {
            return new Date(a.date_till) < new Date(b.date_till)
            // console.log(new Date(a.date_from).getTime() < new Date(b.date_from).getTime());
            // return false;
            return new Date(a.date_from).getTime() < new Date(b.date_from).getTime()
        },
        sortDateTill(a, b) {
            return new Date(a.date_till) > new Date(b.date_till)
        },
        sortDuration(a, b) {
            return a.duration > b.duration
        },
        sortPrice(a, b) {
            return a.price > b.price
        },
        onSort({ column, prop, order }) {
            this.Settings.journeyoverview.defaultsort = { prop, order }
        },
        getJourneyDate(jrn) {
            if (jrn.date_from == jrn.date_till) {
                return new Intl.DateTimeFormat("de-DE", { year: "numeric", month: "2-digit", day: "2-digit" }).format(new Date(jrn.date_from))
            }
            return new Intl.DateTimeFormat("de-DE", { month: "2-digit", day: "2-digit" }).format(new Date(jrn.date_from)) + " - " + new Intl.DateTimeFormat("de-DE", { year: "numeric", month: "2-digit", day: "2-digit" }).format(new Date(jrn.date_till))
        },
        navigateJourney(jrn) {
            core.navigate({ path: "/journeydetail/" + jrn.id_jrn_journey })
        },
        getBookingState(bookable) {
            try {
                return this.bookingStates.find((state) => state.bookable == bookable).name
            } catch (error) {
                return "nicht Buchbar"
            }
        },
    },
}
</script>

<style lang="scss">
#us-all-Journey-cart {
    width: 100%;
    display: flex;
    flex-direction: row;
    flex-flow: wrap;
    align-self: flex-end;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}

.image-slot-error {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    width: 100%;
}

//   .us-all-Journey-table {
//       height:200px;
//       overflow-y:auto;

//   }
//   .usJourneyOverview{
// min-width:320px;
// min-height:320px;
// width:22vw;
// height:22vw;
// position:relative;
// margin:0.5vw;
// margin-bottom:1.5vh;
/* border-radius:5px; */
/* box-sshadow: 0px 0px 10px 0px #979797; */
/* border:1px solid  #979797;     */
//   }
</style>



